import styled, { css } from 'styled-components';
import { filters } from '../../../Filters/verticalFilters/filters';
import { LISTVIEW_SIDEBAR_WIDTH, LISTVIEW_SIDEBAR_WIDTH_LARGE } from '../../../../styles/constants';

const handleSidebarWidth = css`
  width: ${LISTVIEW_SIDEBAR_WIDTH};

  @media (min-width: 1152px) {
    width: ${LISTVIEW_SIDEBAR_WIDTH_LARGE};
  }
`;

export const SidebarContainer = styled.div`
  display: none;
  flex-shrink: 0;
  ${filters};
  ${handleSidebarWidth};
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;
